import enableScrollHandler from 'utils/enableScrollHandler';
import displayNewsCMS from 'utils/displayNewsCMS';
import displayNewsDetailCMS from 'utils/displayNewsDetailCMS';
import displayScheduleCMS from 'utils/displayScheduleCMS';
import displayScheduleDetailCMS from 'utils/displayScheduleDetailCMS';
import * as loadingUtils from 'utils/loading-change';
import * as variables from 'variables';

const sammy = require('sammy');

export default function configCMSDirectioApp() {
	variables.$doc.on('view.scroll.on', (evt, loadDataCallback) => {
		variables.$window.on('scroll', enableScrollHandler);

		variables._scrollTimer = setInterval(() => {
			if (variables._didScroll) {
				variables._didScroll = false;
				// Check position and then
				if (variables.$window.scrollTop() + variables.$window.height() > variables.$doc.height() - 100) {
					// Load in more results
					variables.$doc.trigger('view.load');
					variables._viewPage += 1;
					loadDataCallback(variables._viewPage);
				}
			}
		}, 500);
	});

	variables.$doc.on('view.scroll.off', () => {
		variables.$window.off('scroll', enableScrollHandler);
		clearInterval(variables._scrollTimer);
	});

	variables.$doc.on('view.init', (evt, context) => {
		// ripulisco la vista
		context.app.swap('');
		// attivo il loading
		loadingUtils.activeLoading();

		// se in precedenza era stato creato un player, lo rimuovo con tutti gli eventi
		if (variables._videoPlayer !== undefined) {
			variables._videoPlayer.remove();
		}
		// remove handlers
		variables.$doc.trigger('view.scroll.off');
		// remove timers

		// reset scroll
		window.scrollTo(0, 0);

		// reset page number
		variables._viewPage = 0;
	});

	variables.$doc.on('view.loaded', () => {
		loadingUtils.deactivatesLoading();
		// reset page scroll
	});

	variables.$doc.on('view.load', () => {
		loadingUtils.activeLoading();
		// reset page scroll
	});

	// $.sammy.raise_errors = true;

	sammy('#main-content', function sammyInit() {
		variables._sammy = this; // get a persistent reference to this
		// this.redirect('#/');

		variables._sammy.bind('run', function changedHash() {
			variables._contextOnePage = this;
		});

		variables._sammy.get('#/news/', (context) => {
			variables.$doc.trigger('view.init', [context]);
			displayNewsCMS(context);
		});

		variables._sammy.get('#/news/:id', function changedHash(context) {
			variables.$doc.trigger('view.init', [context]);
			displayNewsDetailCMS(context, this.params.id);
		});

		variables._sammy.get('#/scadenze/', (context) => {
			variables.$doc.trigger('view.init', [context]);
			displayScheduleCMS(context);
		});

		variables._sammy.get('#/scadenze/:id', function changedHash(context) {
			variables.$doc.trigger('view.init', [context]);
			displayScheduleDetailCMS(context, this.params.id);
		});
	}).run('#/news/');
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/configPage/configCMSDirectioApp.js
 **/